import OtmBase from "./otm/OtmBase";
import getOtmPcoman from "../../services/equipment/getOtmPcoman";

const OtmPcoman = ({ codigo }) => {
  if (!codigo) return null; // evita render si no hay código
  
  return (
    <OtmBase
      fetchFn={() => getOtmPcoman(codigo).then((res) => res.otmPcoman)}
      cardStyle="card-teal"
      titulo="OTMs PCOMAN"
    />
  )
};

export default OtmPcoman;